var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('AppHeader',{ref:"header"}):_vm._e(),_c('main',[_c('router-view')],1),(_vm.showFooter)?_c('AppFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }